<template>
  <div class="orderHomepage-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            建店信息
          </div>
          <div v-loading="loading" class="card-content">
            <div class="order-info">
              <span class="tit">项目名称：</span>
              <span>{{ dataDetail.name }}</span>
              <span class="tit mf">创建人：</span>
              <span style="color:#409EFF;font-weight: 500">{{ dataDetail.createname }}</span>
              <span class="tit mf">状态：</span>
              <span v-if="dataDetail.mark===0">平面图</span>
              <span v-if="dataDetail.mark===1">效果图 </span>
              <span v-if="dataDetail.mark===2">施工图</span>
              <span v-if="dataDetail.mark===3">施工交底 </span>
              <span v-if="dataDetail.mark===4">复尺</span>
              <span v-if="dataDetail.mark===5">深化图纸</span>
              <span v-if="dataDetail.mark===6">下单</span>
              <span v-if="dataDetail.mark===9">验收</span>
              <span v-if="dataDetail.mark===100">已完成</span>
            </div>
            <div class="order-info">
              <span class="tit">经销商：</span>
              <span>{{ dataDetail.allname }}</span>
              <span class="tit mf">经销商电话：</span>
              <span>{{ dataDetail.tel }}</span>
            </div>
            <div class="order-info">
              <span class="tit">所在城市：</span>
              <span>{{ dataDetail.province }} {{ dataDetail.city }} {{ dataDetail.county }}</span>
              <span class="tit mf">专卖店地址：</span>
              <span v-if="dataDetail.address!==null&&dataDetail.address!==''&&dataDetail.address!==undefined">{{ dataDetail.address }}</span>
              <span v-if="dataDetail.address===null||dataDetail.address===''||dataDetail.address===undefined">N/A</span>
              <span class="tit mf">专卖店面积：</span>
              <span v-if="dataDetail.storearea!==null&&dataDetail.storearea!==''&&dataDetail.storearea!==undefined">{{ dataDetail.storearea }}/㎡</span>
              <span v-if="dataDetail.storearea===null||dataDetail.storearea===''||dataDetail.storearea===undefined">N/A</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col v-if="dataDetail.mark>=6" class="card mt">
        <div class="card-body">
          <div class="card-title">
            关联订单
            <el-button style="float: right" size="small" icon="el-icon-plus" @click="addSzShopOrder()">添加订单</el-button>
          </div>
          <div v-loading="orderDataLoading" class="card-content">
            <el-table
              :data="orderTableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                label="订单号"
                width="120"
                fixed
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ordernum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="120"
                fixed
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                  <span v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined" style="font-weight: 500;color:#999999">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="delname"
                label="经销商"
                align="center"
                width="120"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="订单类型"
                width="110"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0">正单</span>
                  <span v-if="scope.row.type===1">客改单</span>
                  <span v-if="scope.row.type===2">增补单</span>
                  <span v-if="scope.row.type===3">色板单</span>
                  <span v-if="scope.row.type===4">售后单</span>
                </template>
              </el-table-column>
              <!--<el-table-column
                label="品牌"
                width="130"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="color:#99a9bf">品牌：</span>
                  <span>{{scope.row.brandname}}</span>
                </template>
              </el-table-column>-->
              <el-table-column
                prop="time"
                label="上次操作时间"
                width="170"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="拆单人员"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.splitName!==''&&scope.row.splitName!==null">{{ scope.row.splitName }}</span>
                  <span v-if="scope.row.splitName===''||scope.row.splitName===null" style="color: #99a9bf;">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="详细地址"
                min-width="200"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="当前状态"
                fixed="right"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.dismark===2" :disable-transitions="true" size="mini" type="danger">售后驳回</el-tag>
                  <el-tag v-if="scope.row.dismark===3" :disable-transitions="true" size="mini" type="danger">评估驳回</el-tag>
                  <el-tag v-if="scope.row.dismark===4" :disable-transitions="true" size="mini" type="danger">确认驳回</el-tag>
                  <el-tag v-if="scope.row.dismark===5" :disable-transitions="true" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="scope.row.dismark===6" :disable-transitions="true" size="mini" type="danger">预付驳回</el-tag>
                  <el-tag v-if="scope.row.dismark===7" :disable-transitions="true" size="mini" type="danger">工厂拒接</el-tag>
                  <el-tag v-if="scope.row.dismark===8" :disable-transitions="true" size="mini" type="danger">审单驳回</el-tag>
                  <el-tag v-if="scope.row.mark===2&&scope.row.dismark===0" :disable-transitions="true" size="mini" type="warning">待接单</el-tag>
                  <el-tag v-if="scope.row.mark===3" :disable-transitions="true" size="mini" class="tcf-tag-1">售后处理</el-tag>
                  <el-tag v-if="scope.row.mark===4" :disable-transitions="true" size="mini" class="tcf-tag-5">技术评估</el-tag>
                  <el-tag v-if="scope.row.mark===5" :disable-transitions="true" size="mini" class="tcf-tag-4">拆单分配</el-tag>
                  <el-tag v-if="scope.row.mark===6&&scope.row.dismark===0" :disable-transitions="true" size="mini" class="tcf-tag-2">待拆单</el-tag>
                  <el-tag v-if="scope.row.mark===7&&scope.row.dismark===0" :disable-transitions="true" size="mini" class="tcf-tag-6">订单确认</el-tag>
                  <el-tag v-if="scope.row.mark===8&&scope.row.dismark===0" :disable-transitions="true" size="mini" class="tcf-tag-3">待报价</el-tag>
                  <el-tag v-if="scope.row.mark===9&&scope.row.dismark===0" :disable-transitions="true" size="mini" class="tcf-tag-9">预付款</el-tag>
                  <el-tag v-if="scope.row.mark===10&&scope.row.dismark===0" :disable-transitions="true" size="mini" class="tcf-tag-7">工厂分派</el-tag>
                  <el-tag v-if="scope.row.mark===11" :disable-transitions="true" size="mini" class="tcf-tag-8">工厂接单</el-tag>
                  <el-tag v-if="scope.row.mark===12" :disable-transitions="true" size="mini" class="tcf-tag-10">订单排产</el-tag>
                  <el-tag v-if="scope.row.mark===13" :disable-transitions="true" size="mini" class="tcf-tag-11">订单生产</el-tag>
                  <el-tag v-if="scope.row.mark===88" :disable-transitions="true" size="mini" class="tcf-tag-1">待审单</el-tag>
                  <el-tag v-if="scope.row.mark===99" :disable-transitions="true" size="mini">已取消</el-tag>
                  <el-tag v-if="scope.row.mark===100" :disable-transitions="true" size="mini">已完成</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                fixed="right"
                align="center"
                label="操作"
              >
                <template>
                  <span style="font-size: 13px;color:#99a9bf">订单详情 <i class="el-icon-d-arrow-right"></i></span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="ordertotal>0"
              background
              :current-page="ordercurrentPage"
              :page-sizes="[10, 20, 30]"
              :page-size="orderpageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="ordertotal"
              @size-change="orderHandleSizeChange"
              @current-change="orderHandleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
      <el-col class="card mt">
        <div class="card-body">
          <div class="card-title">
            建店跟踪
            <el-button style="float: right" size="small" icon="el-icon-plus" @click="addDynamic">添加动态</el-button>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="7">
                <el-timeline style="padding: 10px" class="order-track">
                  <el-timeline-item
                    :type="dataDetail.mark>=0?'primary':''"
                    size="large"
                    :timestamp="dataDetail.pmtime"
                  >
                    平面图 <span v-if="dataDetail.pmNo!==null&&dataDetail.pmNo!==''&&dataDetail.pmNo!==undefined&&dataDetail.pmNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.pmNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.pmname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=1?'primary':''"
                    size="large"
                    :timestamp="dataDetail.xgtime"
                  >
                    效果图 <span v-if="dataDetail.xgNo!==null&&dataDetail.xgNo!==''&&dataDetail.xgNo!==undefined&&dataDetail.xgNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.xgNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=2?'primary':''"
                    size="large"
                    :timestamp="dataDetail.sgtime"
                  >
                    施工图 <span v-if="dataDetail.sgNo!==null&&dataDetail.sgNo!==''&&dataDetail.sgNo!==undefined&&dataDetail.sgNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.sgNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=3?'primary':''"
                    size="large"
                    :timestamp="dataDetail.sgjdtime"
                  >
                    施工交底 <span v-if="dataDetail.sgjdNo!==null&&dataDetail.sgjdNo!==''&&dataDetail.sgjdNo!==undefined&&dataDetail.sgjdNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.sgjdNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgjdname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=4?'primary':''"
                    size="large"
                    :timestamp="dataDetail.fctime"
                  >
                    复尺 <span v-if="dataDetail.fcNo!==null&&dataDetail.fcNo!==''&&dataDetail.fcNo!==undefined&&dataDetail.fcNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.fcNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.fcname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=5?'primary':''"
                    size="large"
                    :timestamp="dataDetail.shtztime"
                  >
                    深化图纸 <span v-if="dataDetail.shtzNo!==null&&dataDetail.shtzNo!==''&&dataDetail.shtzNo!==undefined&&dataDetail.shtzNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">未确认{{ dataDetail.shtzNo }}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.shtzname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=6?'primary':''"
                    size="large"
                  >
                    下单
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=9?'primary':''"
                    size="large"
                    :timestamp="dataDetail.ystime"
                  >
                    验收
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.ysname }}</div>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
              <el-col :span="17">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="全部动态" name="a1"></el-tab-pane>
                  <el-tab-pane label="平面图" name="a2"></el-tab-pane>
                  <el-tab-pane label="效果图" name="a3"></el-tab-pane>
                  <el-tab-pane label="施工图" name="a4"></el-tab-pane>
                  <el-tab-pane label="施工交底" name="a5"></el-tab-pane>
                  <el-tab-pane label="复尺" name="a6"></el-tab-pane>
                  <el-tab-pane label="深化图纸" name="a7"></el-tab-pane>
                  <el-tab-pane label="下单" name="a8"></el-tab-pane>
                  <el-tab-pane label="验收" name="a9"></el-tab-pane>
                </el-tabs>
                <div v-if="total===0" class="order-dynamic-not">
                  暂无动态数据
                </div>
                <div v-for="item in dynamicData" class="order-dynamic-item" style="margin-top: 20px;margin-bottom: 20px">
                  <div class="photo">
                    <el-avatar shape="square" :size="50" :src="item.userphoto" style="cursor: pointer;" />
                  </div>
                  <div class="info">
                    <div class="username"><span style="cursor: pointer;">{{ item.username }}</span></div>
                    <div class="time">
                      <i class="el-icon-time" />
                      {{ item.time }}
                    </div>
                    <div class="content">
                      <span style="color: #409EFF">#{{ item.smark===1?'效果图':item.smark===2?'施工图':item.smark===3?'施工交底':item.smark===4?'复尺':item.smark===5?'深化图纸':item.smark===6?'下单':item.smark===9?'验收':'平面图' }}#</span> {{ item.remark }}
                    </div>
                    <div class="files">
                      <div v-for="f in item.filesList" class="file-item" @click="downFile(f.fileid)">
                        <i class="el-icon-document" />
                        <div class="file-name">
                          {{ f.filename }}.{{ f.filetype }}
                        </div>
                      </div>
                    </div>
                    <div class="imgs">
                      <el-image
                        v-for="img in item.srcList"
                        fit="cover"
                        class="dynamic-img"
                        :src="img"
                        :preview-src-list="item.srcList"
                      />
                    </div>
                    <div v-if="(item.smark===0||item.smark===1||item.smark===2||item.smark===5)&&(item.confirmid===null||item.confirmid===undefined||item.confirmid===''||item.confirmid===0)" class="content" style="margin-top: 10px;font-size: 12px;">
                      <i class="el-icon-warning" style="color: #E6A23C;font-size: 13px;"></i> 未确认
                    </div>
                    <div v-if="(item.smark===0||item.smark===1||item.smark===2||item.smark===5)&&item.confirmid!==null&&item.confirmid!==undefined&&item.confirmid!==''&&item.confirmid!==0" class="content" style="margin-top: 10px;font-size: 12px;">
                      <i class="el-icon-success" style="color: #67c23a;font-size: 13px;"></i> 已确认
                      <span style="color: #9aaabf;margin-left: 10px">{{ item.confirmname }} 于 {{ item.confirmtime }}</span>
                    </div>
                  </div>
                </div>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="添加动态"
      :visible.sync="addDynamicVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true"
    >
      <el-form ref="dForm" :model="dForm" :rules="dFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="流程状态" prop="smark">
          <el-select v-model="dForm.smark" style="width: 120px" filterable clearable>
            <el-option v-if="dataDetail.mark>=0" label="平面图" :value="0" />
            <el-option v-if="dataDetail.mark>=1" label="效果图" :value="1" />
            <el-option v-if="dataDetail.mark>=2" label="施工图" :value="2" />
            <el-option v-if="dataDetail.mark>=3" label="施工交底" :value="3" />
            <el-option v-if="dataDetail.mark>=4" label="复尺" :value="4" />
            <el-option v-if="dataDetail.mark>=5" label="深化图纸" :value="5" />
            <el-option v-if="dataDetail.mark>=6" label="下单" :value="6" />
            <el-option v-if="dataDetail.mark>=9" label="验收" :value="9" />
            <!--            <el-option v-if="dataDetail.mark>=100" label="已完成" :value="100"/>-->
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="dForm.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable show-word-limit />
        </el-form-item>
        <el-form-item label="上传图片" prop="images">
          <MultiImg :key="imgkey" v-model="dForm.images" :limit="99" :size="'sm'" />
        </el-form-item>
        <el-form-item label="上传附件" prop="files">
          <MultiFile :key="filekey" v-model="dForm.files" :limit="99" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="btnLoading" @click="submitForm('dForm')">立即提交</el-button>
          <el-button @click="addDynamicVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="添加订单"
      :visible.sync="addOrderVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true"
    >
      <el-form ref="orderForm" :model="orderForm" :rules="orderFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="订单类型" prop="type">
          <el-radio v-model="orderForm.type" :label="0">正单</el-radio>
          <el-radio v-model="orderForm.type" :label="1" @change="changeType">客改单</el-radio>
          <el-radio v-model="orderForm.type" :label="2" @change="changeType">增补单</el-radio>
          <el-radio v-model="orderForm.type" :label="3" @change="changeType">色板单</el-radio>
          <el-radio v-model="orderForm.type" :label="4" @change="changeType">售后单</el-radio>
        </el-form-item>
        <el-form-item v-if="orderForm.type!==0&&isManual===false" label="原正单" prop="oldorderid">
          <OrderSelect :key="orderLoad" v-model="orderForm.oldorderid" :disabled="orderForm.delid===null||orderForm.delid===''" :delid="orderForm.delid" @setOrder="setOrder"></OrderSelect>
          <el-button v-if="orderForm.delid!==null&&orderForm.delid!==''" type="text" icon="el-icon-edit" @click="openManual">找不到原正单，点击这里手动填写</el-button>
        </el-form-item>
        <el-form-item v-if="isManual===true&&orderForm.type!==0" label="原正单" prop="delid">
          <el-col :span="6" style="padding-right: 10px">
            <el-form-item prop="beforenum">
              <el-input v-model="orderForm.beforenum" :disabled="orderForm.delid===null||orderForm.delid===''" placeholder="请输入原正单生产单号" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item prop="beforeyear">
              <el-date-picker
                v-model="orderForm.beforeyear"
                :disabled="orderForm.delid===null||orderForm.delid===''"
                type="year"
                format="yyyy年"
                value-format="yyyy"
                :picker-options="pickerYear"
                placeholder="选择原正单年份"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-button v-if="orderForm.delid!==null&&orderForm.delid!==''" type="text" icon="el-icon-search" @click="isManual=false">点击这里搜索原正单</el-button>
        </el-form-item>
        <el-form-item label="客户名称" prop="custname">
          <el-input v-model="orderForm.custname" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="custtel">
          <el-input v-model="orderForm.custtel" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="orderForm.address" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="订单性质" prop="nature">
          <el-radio v-model="orderForm.nature" :label="0">家装</el-radio>
          <el-radio v-model="orderForm.nature" :label="1">展厅</el-radio>
          <el-radio v-model="orderForm.nature" :label="2">工程</el-radio>
        </el-form-item>
        <el-form-item label="期望交期" prop="exptime">
          <el-date-picker
            v-model="orderForm.exptime"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            placeholder="选择日期"
          >
          </el-date-picker>
          <span style="color:#99a9bf;margin-left: 10px;font-size: 12px;">至少10天以上</span>
        </el-form-item>
        <el-form-item label="品牌" prop="bid">
          <span v-if="orderForm.delid===null||orderForm.delid===''" style="color:#99a9bf;">请先选择经销商</span>
          <el-radio
            v-for="item in brandInfo"
            v-if="orderForm.delid!==null&&orderForm.delid!==''"
            v-model="orderForm.bid"
            :label="item.bid"
          >{{ item.brandname }}</el-radio>
        </el-form-item>
        <el-form-item label="设计师姓名" prop="designer">
          <el-input v-model="orderForm.designer" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="设计师电话" prop="designerTel">
          <el-input v-model="orderForm.designerTel" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="色板来源" prop="source">
          <el-checkbox-group v-model="orderForm.source" @change="changeradio">
            <el-checkbox :label="0">厂部标准色板</el-checkbox>
            <el-checkbox :label="1">客户提供色板</el-checkbox>
            <el-checkbox :label="2">厂部定制色板</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="客供物料" prop="ishaveclient">
          <el-radio v-model="orderForm.ishaveclient" :label="0">无客供物料</el-radio>
          <el-radio v-model="orderForm.ishaveclient" :label="1">有客供物料</el-radio>
          <el-select
            v-if="orderForm.ishaveclient===1"
            v-model="orderForm.client"
            multiple
            filterable
            allow-create
            default-first-option
            style="width: 100%"
            placeholder="请选择或自定义物料名称"
            @change="changeClient"
          >
            <el-option
              v-for="item in clientmaterial"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="orderForm.client.length>0&&orderForm.ishaveclient===1">
          <el-row v-for="item in orderForm.clientInfo" :key="item.key" style="margin-bottom: 10px">
            <el-col :span="14" style="padding-right: 6px">
              <el-form-item>
                <el-input v-model="item.remark" prefix-icon="el-icon-news" placeholder="物料说明" maxlength="30" show-word-limit>
                  <template slot="prepend"><span style="font-weight: bold;margin-right: 10px"><i class="el-icon-paperclip"></i> {{ item.name }}</span></template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item>
                <el-checkbox v-model="item.type">需返还</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="orderForm.client.length>0&&orderForm.ishaveclient===1">
          <div style="font-size: 12px;color:#9aaabf">
            <i class=" el-icon-info"></i> 温馨提示：<br>
            <span>1、由于空气水分灯光等环境因素会导致色板变色，本着彼此负责的态度，凡超过3个月的色板请及时邮寄样品到浙江耐思迪家具有限公司;</span><br>
            <span>2、我们的生产周期将按色板及客供物料到位后开始计算.</span>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="orderForm.remark" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile ref="fileupload" v-model="orderForm.files" style="width: 400px"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <span style="color:#99a9bf; font-size: 12px;">请上传色板照片</span>
          <MultiImg ref="imgupload" v-model="orderForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="orderLoading" @click="onSubmit('orderForm')">立即提交</el-button>
          <el-button @click="resetForm('orderForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import OrderSelect from '@/components/OrderSelect'
import {
  addSzBuildShopDynamic,
  addSzbuildshopOrder, selectSidOrderDataList,
  selectSzBuildShopDetail,
  selectSzBuildShopDynamic
} from '@/api/work'
import { getUser } from '@/utils/auth'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { validatePhoneNumber } from '@/utils/validate'
import { getClientMaterial, getErpDealerBrandList } from '@/api/erp'
import { getFileInfo } from '@/api/pub'
export default {
  name: 'SzjdDetailHomepage',
  components: {
    OrderSelect,
    MultiFile,
    MultiImg
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validateClient = (rule, value, callback) => {
      if (value === 1 && this.orderForm.client.length <= 0) {
        callback(new Error('请选择客供物料'))
      } else {
        callback()
      }
    }
    return {
      sid: null,
      activeName: 'a1',
      dataDetail: '',
      loading: false,
      mark: 0,
      smark: 0,
      addDynamicVisible: false,
      btnLoading: false,
      imgkey: '',
      filekey: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dynamicData: [],
      dForm: {
        sid: null,
        smark: null,
        userid: null,
        remark: '',
        images: [],
        files: []
      },
      dFormRules: {
        smark: [{ required: true, message: '请选择流程状态', trigger: 'change' }],
        remark: [{ required: true, message: '备注不能为空', trigger: 'blur' }]
      },
      addOrderVisible: false,
      isManual: false,
      orderLoad: '',
      brandInfo: [],
      clientmaterial: [],
      orderLoading: false,
      orderForm: {
        num: 0,
        delid: '',
        type: 0,
        nature: 0,
        oldorderid: '',
        beforenum: '',
        beforeyear: '',
        custname: '',
        custtel: '',
        address: '',
        exptime: '',
        designer: '',
        designerTel: '',
        estimated: null,
        bid: null,
        source: [],
        remark: '',
        files: [],
        imgids: [],
        ishaveclient: 0,
        client: [],
        clientInfo: []
      },
      orderFormRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        ishaveclient: [{ required: true, validator: validateClient, trigger: 'change' }],
        nature: [{ required: true, message: '请选择订单性质', trigger: 'change' }],
        oldorderid: [{ required: true, message: '请选择原正单', trigger: 'change' }],
        custname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        custtel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        exptime: [{ required: true, message: '请选择期望交期', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        source: [{ required: true, message: '请选择色板来源', trigger: 'change' }],
        designer: [{ required: true, message: '请输入设计师姓名', trigger: 'blur' }],
        designerTel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        beforenum: [{ required: true, message: '请输入原正单号', trigger: 'blur' }],
        beforeyear: [{ required: true, message: '请选择原正单年份', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },
      orderDataLoading: false,
      orderTableData: [],
      orderpageSize: 10,
      ordercurrentPage: 1,
      ordertotal: 0
    }
  },
  computed: {
    user: getUser,
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() + 9 * 24 * 60 * 60 * 1000
        }
      }
    },
    pickerYear() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now()
        }
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.sid = this.$route.params && this.$route.params.sid
    this.selectSzBuildShopDetail()
    getClientMaterial().then(response => {
      this.clientmaterial = response.data
    }).catch(() => {
      this.clientmaterial = []
    })
  },
  methods: {
    handleClick(tab, event) {
      this.smark = tab.index
      this.currentPage = 1
      this.searchDynamic()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.orderid })
    },
    selectSidOrderDataList() {
      this.orderDataLoading = true
      const data = {
        sid: this.sid,
        page: this.ordercurrentPage,
        limit: this.orderpageSize
      }
      selectSidOrderDataList(data).then(response => {
        this.orderTableData = response.data
        this.ordertotal = response.total
        this.orderDataLoading = false
      }).catch(() => {

      })
    },
    orderHandleSizeChange(val) {
      this.orderpageSize = val
      this.selectSidOrderDataList()
    },
    orderHandleCurrentChange(val) {
      this.ordercurrentPage = val
      this.selectSidOrderDataList()
    },
    addSzShopOrder() {
      this.orderForm.delid = this.dataDetail.delid
      this.orderLoad = new Date().getTime()
      getErpDealerBrandList({ delid: this.dataDetail.delid }).then(response => {
        this.brandInfo = response.data
        if (this.brandInfo.length > 0) {
          this.orderForm.bid = this.brandInfo[0].bid
        }
      }).catch(() => {
        this.brandInfo = []
        this.orderForm.bid = null
      })
      this.addOrderVisible = true
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.orderLoading) {
            this.orderLoading = true
            let clientInfo = ''
            if (this.orderForm.ishaveclient === 1) {
              clientInfo = qs.parse(this.orderForm.clientInfo)
            }
            const data = {
              clientInfo: clientInfo,
              replaceid: this.user.dUserid,
              delid: this.orderForm.delid,
              type: this.orderForm.type,
              nature: this.orderForm.nature,
              oldorderid: this.orderForm.oldorderid,
              beforenum: this.orderForm.beforenum,
              beforeyear: this.orderForm.beforeyear,
              custname: this.orderForm.custname,
              custtel: this.orderForm.custtel,
              address: this.orderForm.address,
              exptime: this.orderForm.exptime,
              designer: this.orderForm.designer,
              designerTel: this.orderForm.designerTel,
              estimated: this.orderForm.estimated,
              bid: this.orderForm.bid,
              source: this.orderForm.source.join(','),
              remark: this.orderForm.remark,
              fileids: this.orderForm.files.join(','),
              imgids: this.orderForm.imgids.join(','),
              sid: this.sid
            }
            addSzbuildshopOrder(data).then(response => {
              this.orderLoading = false
              this.$message({
                message: '订单录入成功',
                type: 'success'
              })
              this.resetForm(formName)
              this.ordercurrentPage = 1
              this.selectSzBuildShopDetail()
              this.addOrderVisible = false
            }).catch(() => {
              this.orderLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs['fileupload'].clearMultiFile()
      this.$refs['imgupload'].clearMultiImg()
      this.orderForm.oldorderid = ''
      this.orderForm.beforenum = ''
      this.orderForm.beforeyear = ''
    },
    changeClient() {
      if (this.orderForm.client.length > 0) {
        const _clientInfo = []
        for (const c of this.orderForm.client) {
          _clientInfo.push({ name: c, type: 0, remark: '' })
        }
        this.orderForm.clientInfo = _clientInfo
      } else {
        this.orderForm.clientInfo = []
      }
    },
    changeradio() {
      for (const s of this.orderForm.source) {
        if (s === 1) {
          this.orderForm.ishaveclient = 1
          let num = 0
          for (const c of this.orderForm.client) {
            if (c === '色板') {
              num = 1
            }
          }
          if (num === 0) {
            this.orderForm.client.push('色板')
            const _clientInfo = []
            for (const c of this.orderForm.client) {
              _clientInfo.push({ name: c, type: 0, remark: '' })
            }
            this.orderForm.clientInfo = _clientInfo
          }
        }
      }
    },
    setOrder(data) {
      this.orderForm.nature = data.nature
      this.orderForm.custname = data.custname
      this.orderForm.custtel = data.custtel
      this.orderForm.address = data.address
      if (data.bid === 3) {
        this.orderForm.beforenum = data.ordernum
      } else {
        this.orderForm.beforenum = data.produnum
      }
      this.orderForm.beforeyear = data.time.substring(0, 4)
      this.orderForm.bid = data.bid
      this.orderForm.designer = data.designer
      this.orderForm.designerTel = data.designerTel
      this.orderForm.source = []
    },
    openManual() {
      this.orderForm.oldorderid = ''
      this.orderForm.beforenum = ''
      this.orderForm.beforeyear = ''
      this.isManual = true
    },
    changeType(val) {
      if (val === 3) {
        this.orderFormRules.oldorderid[0].required = false
        this.orderFormRules.beforenum[0].required = false
        this.orderFormRules.beforeyear[0].required = false
      } else {
        this.orderFormRules.oldorderid[0].required = true
        this.orderFormRules.beforenum[0].required = true
        this.orderFormRules.beforeyear[0].required = true
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.searchDynamic()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchDynamic()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.btnLoading) {
            this.btnLoading = true
            const data = {
              sid: this.dataDetail.sid,
              smark: this.dForm.smark,
              userid: this.user.dUserid,
              remark: this.dForm.remark,
              imgids: this.dForm.images.toString(),
              fileids: this.dForm.files.toString()
            }
            addSzBuildShopDynamic(data).then(response => {
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.currentPage = 1
              this.selectSzBuildShopDetail()
              this.searchDynamic()
              this.addDynamicVisible = false
              this.btnLoading = false
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    addDynamic() {
      this.imgkey = new Date().getTime() + 1
      this.filekey = new Date().getTime() + 2
      this.dForm.sid = null
      this.dForm.smark = null
      this.dForm.remark = null
      this.dForm.files = []
      this.dForm.images = []
      this.dForm.userid = null
      this.addDynamicVisible = true
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    searchDynamic() {
      if (this.dataDetail.mark >= 6) {
        this.selectSidOrderDataList()
      }
      const data = {
        sid: this.sid,
        smark: this.smark,
        page: this.currentPage,
        limit: this.pageSize
      }
      selectSzBuildShopDynamic(data).then(response => {
        this.dynamicData = response.data
        this.total = response.total
      })
    },
    selectSzBuildShopDetail() {
      this.loading = true
      const data = {
        sid: this.sid
      }
      selectSzBuildShopDetail(data).then(response => {
        this.dataDetail = response.data
        const pageTitle = `${response.data.name}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.searchDynamic()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.orderHomepage-container{
  .mt{
    margin-top: 20px;
  }
  .order-info{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .tit{
      color:#99a9bf;
    }
    .price{
      color:#F56C6C;
      font-weight: 500;
    }
    .mf{
      margin-left: 30px
    }
    .link{
      color:#409EFF;
      cursor: pointer;
      font-weight: 500;
      &:hover{
        opacity: 0.8;
      }
    }
    .file-item{
      cursor: pointer;
      background: #f6f7fa;
      color:#909399;
      padding: 10px 10px 10px 44px;
      position: relative;
      width: 100%;
      i{
        position: absolute;
        font-size: 30px;
        left: 10px;
        top:10px;
      }
      .file-name{
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 15px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        color:#409EFF;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  .info-ellipsis{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order-track{
    overflow-x: auto;
    overflow-y: hidden;
    .order-track-info{
      width: 2240px;
      position: relative;
      .el-steps{
        .el-step{
          flex-basis: 160px!important;
        }
      }
    }
  }
  .order-dynamic-not{
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 12px;
    color:#999;
    text-align: center;
  }
  .order-dynamic-item{
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f5f7fa;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 60px;
    .photo{
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top:0;
    }
    .info{
      position: relative;
      padding-right: 40px;
      width: 100%;
      .username{
        margin-bottom: 6px;
        span{
          &:first-child{
            font-size: 14px;
            font-weight: 500;
            margin-right: 6px;
          }
        }
      }
      .time{
        font-size: 12px;
        color:#999;
        margin-bottom: 6px;
        position: absolute;
        right: 0;
        top:4px;
      }
      .content{
        margin-bottom: 6px;
      }
      .files{
        position: relative;
        width: 100%;
        .file-item{
          cursor: pointer;
          float: left;
          background: #f6f7fa;
          color:#909399;
          padding: 10px 10px 10px 44px;
          position: relative;
          width: 200px;
          margin-right: 10px;
          margin-bottom: 6px;
          .el-icon-document{
            position: absolute;
            font-size: 30px;
            left: 10px;
            top:10px;
          }
          .file-name{
            width: 100%;
            height: 30px;
            font-size: 12px;
            line-height: 15px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .lessonplay{
            width: 100%;
            height: 100%;
            display: none;
            position: absolute;
            top:0;
            left: 0;
            background: rgba(0,0,0,0.6);
            color:#fff;
            text-align: center;
            line-height: 50px;
            span{
              margin-right: 20px;
              font-weight: bold;
              &:hover{
                color:#94c8fc;
              }
              &:last-child{
                margin-right: 0;
              }
            }
          }
          &:hover{
            .lessonplay{
              display: block;
            }
          }
        }
        .dwg{
          padding: 10px 50px 10px 44px;
          .online-view{
            width: 50px;
            position: absolute;
            right: 0;
            top:0;
          }
        }
        &:after,&:before{
          content: '';
          display: block;
          clear: both;
        }
      }
      .imgs{
        .dynamic-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
    &:last-child{
      border-bottom: 0px;
    }
  }
  .user-item{
    color:#99a9bf;
    margin-bottom: 20px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    span{
      font-weight: 400;
      color: #606266;
    }
    i{
      margin-right: 5px;
    }
  }
  .menu-list{
    width: 100%;
    position: relative;
    .menu-item{
      float: left;
      width: 80px;
      margin: 4px 10px 10px 0;
      padding:10px;
      position: relative;
      border-radius: 2px;
      cursor: pointer;
      .menu-item-img{
        text-align: center;
        width: 100%;
        svg{
          width: 50px!important;
          height: 50px!important;
        }
      }
      .menu-item-name{
        width: 100%;
        text-align: center;
        padding-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
      }
      .el-badge__content{
        top: 20px!important;
        right: 30px!important;
      }
      &:hover{
        background: #f5f7fa;
      }
    }
    &:after{
      content: ' ';
      clear: both;
      display: table;
    }
  }
}
</style>
